import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { SUPPORTED_STREAM } from '../../constants';
import Utils from '../../utils/Utils';
import PosterTitleTrash from '../posters/PosterTitleTrash';
import PosterTitle from '../posters/PosterTitle';
import PosterFormatType from '../posters/PosterFormatType';

const ContentItemRecord = props => {
  const {
    redirectRecording,
    size,
    onImageError,
    item,
    sizeAlt,
    isPlayAndGo,
    apaAssets,
    isRecording,
    isHighlight,
    userType,
    urlPlayer,
    recordingList,
    imagesSize = {},
    name,
  } = props;

  const imgClass = isPlayAndGo ? 'horizontal foxcarr' : 'horizontal';
  let isIngested = true;
  let actionRecording;
  let redirectLink = '';
  let isRecording_;

  if (item.id || item.group_id || item.type) {
    redirectLink = Utils.buildRedirect({ content: item, userType, urlPlayer });
  } else {
    redirectLink = { redirectUrl: window.location.pathname };
  }

  item.isRecording = isRecording;

  if (recordingList && recordingList.length > 0) {
    recordingList.forEach(value => {
      if (value.channel.event.id === item.id) {
        actionRecording = value.actions;
      }
    });
  }
  if (name === 'Mis-programas-grabados') {
    const deviceSO = Utils.getDeviceOS();
    let isSoported = false;
    if (actionRecording && actionRecording.play) {
      SUPPORTED_STREAM[deviceSO].forEach(value => {
        if (actionRecording.play[value]) {
          isSoported = true;
        }
      });
    }
    if (isSoported) {
      redirectLink.redirectUrl = item.group_id;
      //redirectLink.redirectUrl = ClaroUrlBuilder.playerRecord(item.group_id);
    } else {
      redirectLink.redirectUrl = false;
    }
    isIngested = true;
  } else if (name === 'Por-grabar') {
    isIngested = false;
    isRecording_ = false;
    if (recordingList) {
      recordingList.forEach(value => {
        if (
          value.channel.event.id === item.id &&
          value.status === 'recording'
        ) {
          isRecording_ = true;
        }
      });
    }
    redirectLink = false;
  }

  if (isPlayAndGo && apaAssets) {
    if (apaAssets[item[size]]) {
      item[size] = apaAssets[item[size]];
    }
    if (sizeAlt && apaAssets[item[sizeAlt]]) {
      item[sizeAlt] = apaAssets[item[sizeAlt]];
    }
  }
  return (
    <div className="content-item">
      <a className="item-img" onClick={e => redirectRecording(e, redirectLink, actionRecording, item)}>
        {
          <img
            src={item[size]}
            onError={onImageError}
            className={`${imgClass} imgCR`}
            height={imagesSize.height}
          />
        }
        {
          <img
            src={sizeAlt ? item[sizeAlt] : item[size]}
            onError={onImageError}
            height={imagesSize.height}
            className={isPlayAndGo ? 'vertical imgCR foxcarr' : 'vertical'}
          />
        }
        {!isRecording_ && !isIngested && (
          <img
            className="icon-inline img-recording"
            src={apaAssets.npvr_record_asset_status}
            style={{ width: '25px', height: '20px', zIndex: '2' }}
          />
        )}
        {isRecording_ && (
          <img
            className="icon-inline img-recording"
            src={apaAssets.npvr_recording_asset_status}
            style={{ width: '25px', height: '20px', zIndex: '2' }}
          />
        )}
        {!isPlayAndGo && isIngested && (
          <span className="play">
            <i className="fa fa-play-circle-o" />
          </span>
        )}
        <PosterFormatType item={item}/>
        <MediaQuery query="(min-width: 768px)">
          {!isHighlight && <PosterTitle resource={item} />}
        </MediaQuery>
      </a>{' '}
      {isRecording && (
        <PosterTitleTrash resource={item} actionRecording={actionRecording} />
      )}
    </div>
  );
};

ContentItemRecord.propTypes = {
  redirectRecording: PropTypes.func,
  size: PropTypes.string,
  onImageError: PropTypes.func,
  item: PropTypes.string,
  sizeAlt: PropTypes.string,
  isPlayAndGo: PropTypes.bool,
  apaAssets: PropTypes.object,
  isRecording: PropTypes.bool,
  isHighlight: PropTypes.bool,
  userType: PropTypes.object,
  urlPlayer: PropTypes.object,
  recordingList: PropTypes.array,
  imagesSize: PropTypes.object,
  name: PropTypes.string,
};

export default ContentItemRecord;
